import React from 'react'
import { useState } from 'react'
import './App.css'
import { NavLink, useNavigate } from 'react-router-dom'
import { useCart } from 'react-use-cart';
const Login = (props) => {
    const done=useNavigate();
    const[data,setdata]=useState([])
    const[input,setinput]=useState({
      email:"",
      password:""
    })
    const handleClick = () => {
      window.location.reload(false);
    };
    const getdata=(e)=>{
        const { name , value}=e.target;
        setinput({
            ...input,
            [name]:value
        })
       }
       const handleSubmit = (e) => {
        e.preventDefault();
        const{email,password}=input;
       const getUserArr=localStorage.getItem("userKicks");
       console.log(getUserArr);
       if(getUserArr && getUserArr.length){
        const userData = JSON.parse(getUserArr)
       const userLogin=userData.filter((el,k)=>{
        return el.email===email && el.password===password
       });
       console.log(userLogin)
       if(userLogin.length==0){
        alert("invalid details");
       }
       else{
        done("/home")
       }
       }
      }
      const {
        emptyCart,
    }=useCart();
  return (
    <div className='w-full h-full fixed z-50 left-0 top-0 bg-black bg-opacity-80'>
        <div className='signup2 bg-white w-96 h-min relative left-[500px] top-48'>
          <span class="material-symbols-outlined relative top-[10px] left-[170px] text-black" onClickCapture={()=>{props.cancel()}}><NavLink to='/'>close</NavLink></span>
       <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            className="mx-auto h-10 w-auto"
            src="https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600"
            alt="Your Company"
          />
          <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Sign in to your account
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" action="#">
            <div>
              <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                Email address
              </label>
              <div className="mt-2">
                <input
                onChange={getdata}
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  placeholder='Enter email'
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                  Password
                </label>
                <div className="text-sm">
                  <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">
                    Forgot password?
                  </a>
                </div>
              </div>
              <div className="mt-2">
                <input
                 onChange={getdata}
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  placeholder='Enter Password'
                  required
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                onClick={emptyCart()}
                onClickCapture={handleSubmit}
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Sign in
              </button>
            </div>
          </form>
          <p className="mt-10 text-center text-sm text-gray-500">
          <a href="#" className="font-semibold leading-6 ">
            Not a member? <span className='text-indigo-600' ><NavLink to='/'>Sign Up</NavLink></span>
            </a>
          </p>
        </div>
      </div>
      </div>
    </div>
  )
}
export default Login
